(function () {
  'use strict';

  /*
   * Prevent duplicate listeners when Shopify
   * reloads the header in the Theme Editor.
   */
  if (window.RyzemeCleanHeaderInitialized) {
    return;
  }

  window.RyzemeCleanHeaderInitialized = true;


  function closeExplore(header) {
    if (!header) {
      return;
    }

    var button =
      header.querySelector(
        '[data-ryz-explore-toggle]'
      );

    var panel =
      header.querySelector(
        '[data-ryz-explore-panel]'
      );

    header.classList.remove(
      'ryz-explore-open'
    );

    if (button) {
      button.setAttribute(
        'aria-expanded',
        'false'
      );
    }

    if (panel) {
      panel.hidden = true;
    }
  }


  function openExplore(header) {
    if (!header) {
      return;
    }

    var button =
      header.querySelector(
        '[data-ryz-explore-toggle]'
      );

    var panel =
      header.querySelector(
        '[data-ryz-explore-panel]'
      );

    if (!button || !panel) {
      return;
    }

    header.classList.add(
      'ryz-explore-open'
    );

    button.setAttribute(
      'aria-expanded',
      'true'
    );

    panel.hidden = false;
  }


  document.addEventListener(
    'click',
    function (event) {

      var toggle =
        event.target.closest(
          '[data-ryz-explore-toggle]'
        );

      if (toggle) {

        event.preventDefault();

        var header =
          toggle.closest('#header');

        if (!header) {
          return;
        }

        var isOpen =
          header.classList.contains(
            'ryz-explore-open'
          );

        if (isOpen) {
          closeExplore(header);
        } else {
          openExplore(header);
        }

        return;
      }


      var openHeader =
        document.querySelector(
          '#header.ryz-explore-open'
        );

      if (!openHeader) {
        return;
      }


      var panel =
        openHeader.querySelector(
          '[data-ryz-explore-panel]'
        );


      if (
        panel &&
        !panel.contains(event.target)
      ) {
        closeExplore(openHeader);
      }

    }
  );


  document.addEventListener(
    'keydown',
    function (event) {

      if (event.key !== 'Escape') {
        return;
      }

      var openHeader =
        document.querySelector(
          '#header.ryz-explore-open'
        );

      if (!openHeader) {
        return;
      }

      closeExplore(openHeader);

      var button =
        openHeader.querySelector(
          '[data-ryz-explore-toggle]'
        );

      if (button) {
        button.focus();
      }

    }
  );


  window.addEventListener(
    'resize',
    function () {

      if (window.innerWidth >= 1200) {
        return;
      }

      var openHeader =
        document.querySelector(
          '#header.ryz-explore-open'
        );

      if (openHeader) {
        closeExplore(openHeader);
      }

    }
  );
  /* =========================================================
   DESKTOP HOVER - EXPLORE MENU
========================================================= */

var hoverCloseTimer = null;

function cancelExploreHoverClose() {
  if (hoverCloseTimer) {
    window.clearTimeout(hoverCloseTimer);
    hoverCloseTimer = null;
  }
}

function scheduleExploreHoverClose(header) {
  cancelExploreHoverClose();

  hoverCloseTimer = window.setTimeout(
    function () {
      closeExplore(header);
    },
    180
  );
}

var exploreToggle =
  document.querySelector(
    '#header [data-ryz-explore-toggle]'
  );

var explorePanel =
  document.querySelector(
    '#header [data-ryz-explore-panel]'
  );

if (exploreToggle && explorePanel) {

  /* Open when mouse enters Explore */
  exploreToggle.addEventListener(
    'mouseenter',
    function () {

      if (window.innerWidth < 1200) {
        return;
      }

      cancelExploreHoverClose();

      var header =
        exploreToggle.closest('#header');

      if (header) {
        openExplore(header);
      }
    }
  );


  /* Allow time to move mouse from Explore to panel */
  exploreToggle.addEventListener(
    'mouseleave',
    function () {

      if (window.innerWidth < 1200) {
        return;
      }

      var header =
        exploreToggle.closest('#header');

      if (header) {
        scheduleExploreHoverClose(header);
      }
    }
  );


  /* Keep panel open while mouse is inside it */
  explorePanel.addEventListener(
    'mouseenter',
    function () {

      if (window.innerWidth < 1200) {
        return;
      }

      cancelExploreHoverClose();
    }
  );


  /* Close after leaving dropdown */
  explorePanel.addEventListener(
    'mouseleave',
    function () {

      if (window.innerWidth < 1200) {
        return;
      }

      var header =
        explorePanel.closest('#header');

      if (header) {
        scheduleExploreHoverClose(header);
      }
    }
  );

}

/* =========================================================
   RYZEMÉ CART SYNC
   Syncs third-party AJAX cart changes (Shoply AI etc.)
   with the Shella header cart counter.
========================================================= */

var ryzCartSyncTimer = null;

var ryzCartRequestPattern =
  /\/cart\/(add|change|update)(\.js)?(?:\?|$)/i;


/* ---------------------------------------------------------
   READ LIVE SHOPIFY CART
--------------------------------------------------------- */

function syncRyzemeCart() {

  var shopRoot = '/';

  if (
    window.Shopify &&
    Shopify.routes &&
    Shopify.routes.root
  ) {
    shopRoot = Shopify.routes.root;
  }


  fetch(shopRoot + 'cart.js', {
    method: 'GET',
    credentials: 'same-origin',
    cache: 'no-store',
    headers: {
      'Accept': 'application/json'
    }
  })
    .then(function (response) {

      if (!response.ok) {
        throw new Error(
          'Unable to read Shopify cart'
        );
      }

      return response.json();

    })
    .then(function (cart) {

      var count =
        parseInt(cart.item_count, 10) || 0;


      /* -----------------------------------------------
         DESKTOP HEADER COUNT
      ----------------------------------------------- */

      document
        .querySelectorAll(
          '[data-js-cart-count-desktop]'
        )
        .forEach(function (counter) {

          counter.textContent =
            '(' + count + ')';

          counter.setAttribute(
            'data-js-cart-count-desktop',
            '(' + count + ')'
          );

        });


      /* -----------------------------------------------
         STANDARD MOBILE HEADER COUNT
      ----------------------------------------------- */

      document
        .querySelectorAll(
          '[data-js-cart-count-mobile]'
        )
        .forEach(function (counter) {

          counter.textContent = count;

          counter.setAttribute(
            'data-js-cart-count-mobile',
            count
          );

        });


      /* -----------------------------------------------
         MOBILE BOTTOM BAR COUNT
      ----------------------------------------------- */

      document
        .querySelectorAll(
          '.mobile-bottom-bar__item--cart'
        )
        .forEach(function (cartButton) {

          var badge =
            cartButton.querySelector(
              '.mobile-bottom-bar__count'
            );


          if (count > 0) {

            if (!badge) {

              badge =
                document.createElement(
                  'span'
                );

              badge.className =
                'mobile-bottom-bar__count';

              cartButton.appendChild(
                badge
              );

            }

            badge.textContent = count;

          } else if (badge) {

            badge.remove();

          }

        });


      /* -----------------------------------------------
         CUSTOM EVENT
         Can be reused later if needed.
      ----------------------------------------------- */

      document.dispatchEvent(
        new CustomEvent(
          'ryzeme:cart-synced',
          {
            detail: {
              cart: cart
            }
          }
        )
      );

    })
    .catch(function (error) {

      console.warn(
        'Ryzemé cart sync:',
        error
      );

    });

}


/* ---------------------------------------------------------
   SCHEDULE SYNC
   Multiple checks handle apps that update cart slowly.
--------------------------------------------------------- */

function scheduleRyzemeCartSync() {

  if (ryzCartSyncTimer) {
    window.clearTimeout(
      ryzCartSyncTimer
    );
  }


  ryzCartSyncTimer =
    window.setTimeout(
  function () {
    syncRyzemeCart();
    refreshRyzemeMiniCart();
  },
  300
);


window.setTimeout(
  function () {
    syncRyzemeCart();
    refreshRyzemeMiniCart();
  },
  900
);


window.setTimeout(
  function () {
    syncRyzemeCart();
    refreshRyzemeMiniCart();
  },
  1800
);

}


/* ---------------------------------------------------------
   SHOPIFY CART EVENT
--------------------------------------------------------- */

document.addEventListener(
  'shopify:cart:lines-update',
  scheduleRyzemeCartSync
);


/* ---------------------------------------------------------
   WATCH FETCH CART REQUESTS
--------------------------------------------------------- */

if (
  window.fetch &&
  !window.RyzemeCartFetchPatched
) {

  window.RyzemeCartFetchPatched = true;

  var originalRyzemeFetch =
    window.fetch;


  window.fetch = function () {

    var fetchArguments = arguments;

    var request =
      fetchArguments[0];

    var requestUrl = '';


    if (
      typeof request === 'string'
    ) {

      requestUrl = request;

    } else if (
      request &&
      request.url
    ) {

      requestUrl =
        request.url;

    }


    return originalRyzemeFetch
      .apply(
        this,
        fetchArguments
      )
      .then(function (response) {

        if (
          requestUrl &&
          ryzCartRequestPattern.test(
            requestUrl
          )
        ) {

          scheduleRyzemeCartSync();

        }

        return response;

      });

  };

}


/* ---------------------------------------------------------
   WATCH XMLHttpRequest CART REQUESTS
   Supports apps using older AJAX requests.
--------------------------------------------------------- */

if (
  window.XMLHttpRequest &&
  !window.RyzemeCartXhrPatched
) {

  window.RyzemeCartXhrPatched = true;


  var originalRyzemeXhrOpen =
    XMLHttpRequest.prototype.open;

  var originalRyzemeXhrSend =
    XMLHttpRequest.prototype.send;


  XMLHttpRequest.prototype.open =
    function (
      method,
      url
    ) {

      this._ryzemeCartRequest =
        typeof url === 'string' &&
        ryzCartRequestPattern.test(
          url
        );


      return originalRyzemeXhrOpen
        .apply(
          this,
          arguments
        );

    };


  XMLHttpRequest.prototype.send =
    function () {

      var xhr = this;


      if (
        xhr._ryzemeCartRequest
      ) {

        xhr.addEventListener(
          'load',
          function () {

            if (
              xhr.status >= 200 &&
              xhr.status < 400
            ) {

              scheduleRyzemeCartSync();

            }

          }
        );

      }


      return originalRyzemeXhrSend
        .apply(
          this,
          arguments
        );

    };

}


/* ---------------------------------------------------------
   INITIAL SYNC
--------------------------------------------------------- */


/* =========================================================
   RYZEMÉ - REFRESH SHELLA MINI CART
   Reloads fresh cart-drawer HTML without refreshing the page
========================================================= */

function refreshRyzemeMiniCart() {

  /*
   * Shella versions use slightly different
   * cart popup selectors, so try supported candidates.
   */
  var cartPopupSelectors = [
    '[data-js-popup-name="cart"]',
    '[data-js-popup="cart"]',
    '.popup-cart',
    '.cart-popup',
    '.popup--cart',
    '.cart-drawer'
  ];


  function findCartPopup(root) {

    for (
      var i = 0;
      i < cartPopupSelectors.length;
      i++
    ) {

      var popup =
        root.querySelector(
          cartPopupSelectors[i]
        );

      if (popup) {
        return {
          element: popup,
          selector: cartPopupSelectors[i]
        };
      }

    }

    return null;
  }


  var currentPopup =
    findCartPopup(document);


  /*
   * If Shella has not created the popup yet,
   * there is nothing to replace.
   */
  if (!currentPopup) {

    console.warn(
      'Ryzemé: Shella mini-cart element not found.'
    );

    return Promise.resolve(false);
  }


  var pageUrl =
    window.location.pathname +
    window.location.search;

  var separator =
    pageUrl.indexOf('?') === -1
      ? '?'
      : '&';

  pageUrl +=
    separator +
    '_ryz_cart_refresh=' +
    Date.now();


  return fetch(pageUrl, {
    method: 'GET',
    credentials: 'same-origin',
    cache: 'no-store',
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
    .then(function (response) {

      if (!response.ok) {
        throw new Error(
          'Unable to refresh mini cart'
        );
      }

      return response.text();

    })
    .then(function (html) {

      var parser =
        new DOMParser();

      var freshDocument =
        parser.parseFromString(
          html,
          'text/html'
        );


      var freshPopup =
        findCartPopup(
          freshDocument
        );


      if (!freshPopup) {

        console.warn(
          'Ryzemé: Fresh Shella mini-cart markup not found.'
        );

        return false;
      }


      /*
       * Preserve the current drawer container itself
       * and replace only its contents.
       *
       * This is safer than replacing the entire popup
       * because Shella may have listeners on the root.
       */
      currentPopup.element.innerHTML =
        freshPopup.element.innerHTML;


      /*
       * Notify any theme/app listeners that cart UI
       * has changed.
       */
      document.dispatchEvent(
        new CustomEvent(
          'ryzeme:minicart-refreshed'
        )
      );


      document.dispatchEvent(
        new CustomEvent(
          'cart:refresh',
          {
            bubbles: true
          }
        )
      );


      if (
        window.jQuery &&
        typeof window.jQuery ===
          'function'
      ) {

        window.jQuery(
          document.body
        ).trigger(
          'cart:refresh'
        );

      }


      return true;

    })
    .catch(function (error) {

      console.warn(
        'Ryzemé mini-cart refresh:',
        error
      );

      return false;

    });

}
syncRyzemeCart();
})();